import type { RouteLocationNormalized, Router } from "vue-router";

export const clientRouteName = {
  index: "clients.index",
  show: "clients.show",
};

export const clientRoute = [
  {
    path: "/clients",
    name: clientRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_entity",
      breadcrumbs: () => {
        return [{ title: "Client" }];
      },
    },
  },
  {
    path: "/clients/:id",
    name: clientRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_entity",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: clientRouteName.index }).path, title: "Client" }, { title: "Detail" }];
      },
    },
  },
];
